import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import actionDropdown from './actionDropdown.js'

export default contract({
  actionDropdown: array([
    actionDropdown
  ])
})
